import { Play, CalendarDays, BarChart3, MessageCircle, Radio, Infinity as InfinityIcon, FileText, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const IG_DM = "https://ig.me/m/bctrades__";

const COURSE_FEATURES = [
  { icon: Play, title: "+30 vídeos exclusivos", sub: "Toda la estrategia, paso a paso." },
  { icon: CalendarDays, title: "Reviews diarios y vídeos semanales", sub: "Análisis de operaciones y nuevas oportunidades cada semana." },
  { icon: BarChart3, title: "Análisis diario", sub: "Dirección, objetivos y actualización de cada sesión." },
  { icon: MessageCircle, title: "Acompañamiento personal", sub: "Número privado + grupo exclusivo de la comunidad." },
  { icon: Radio, title: "Directos semanales", sub: "Sesiones en vivo para resolver dudas y analizar el mercado." },
  { icon: InfinityIcon, title: "Acceso para siempre", sub: "Contenido y actualizaciones de por vida." },
];

const PDF_POINTS = ["Acceso inmediato", "Contenido claro y estructurado", "Sin acompañamiento ni grupo"];

export const Pricing = () => (
  <section
    id="productos"
    data-testid="pricing-section"
    className="relative border-t border-[#5EA2FF]/15 px-6 py-28 sm:px-12 lg:px-20 lg:py-40"
  >
    <Reveal>
      <p className="font-mono text-[11px] tracking-[0.4em] text-[#5EA2FF] sm:text-xs">
        {"// 03 — ACCESO"}
      </p>
      <h2 className="mt-6 font-display text-4xl font-bold uppercase leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-6xl">
        Elige tu <span className="text-stroke-blue">camino.</span>
      </h2>
    </Reveal>

    <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-2">
      <Reveal className="h-full">
        <article
          data-testid="pricing-card-formation"
          className="group relative flex h-full flex-col border border-[#2F7DF6]/50 bg-[#061226] shadow-[0_0_80px_-20px_rgba(47,125,246,0.35)] transition-shadow duration-500 hover:shadow-[0_0_120px_-20px_rgba(47,125,246,0.5)]"
        >
          <span className="absolute -top-px right-6 bg-[#2F7DF6] px-4 py-1.5 font-mono text-[10px] font-bold tracking-[0.25em] text-white">
            MÁS COMPLETO
          </span>
          <div className="p-8 lg:p-10">
            <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-[#5EA2FF] sm:text-3xl">
              Formación completa
            </h3>
            <ul className="mt-8 divide-y divide-[#5EA2FF]/10">
              {COURSE_FEATURES.map((f) => (
                <li key={f.title} className="flex items-start gap-4 py-4">
                  <f.icon className="mt-0.5 h-5 w-5 shrink-0 text-[#2F7DF6]" />
                  <div>
                    <p className="font-mono text-xs font-bold tracking-[0.15em] text-white">{f.title.toUpperCase()}</p>
                    <p className="mt-1 text-sm text-[#7A90B8]">{f.sub}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-auto border-t border-[#2F7DF6]/30 p-8 text-center lg:p-10">
            <p className="font-display text-5xl font-extrabold tracking-tight text-white">1.000 €</p>
            <p className="mt-2 font-mono text-xs font-bold tracking-[0.3em] text-[#5EA2FF]">
              FRACCIONADO MENSUALMENTE
            </p>
            <p className="mx-auto mt-4 inline-block border border-[#5EA2FF]/25 px-4 py-2 font-mono text-[11px] text-[#7A90B8]">
              Por ejemplo: 100 € en 10 meses · 160 € en 6 meses
            </p>
            <a
              data-testid="pricing-cta-formation-button"
              href={IG_DM}
              target="_blank"
              rel="noopener noreferrer"
              className="group/btn mt-8 flex items-center justify-center gap-3 bg-[#2F7DF6] px-7 py-4 font-mono text-xs font-bold tracking-[0.25em] text-white transition-colors duration-300 hover:bg-[#5EA2FF]"
            >
              QUIERO LA FORMACIÓN
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover/btn:-translate-y-0.5 group-hover/btn:translate-x-0.5" />
            </a>
          </div>
        </article>
      </Reveal>

      <Reveal delay={0.12} className="h-full">
        <article
          data-testid="pricing-card-pdf"
          className="flex h-full flex-col border border-[#5EA2FF]/20 bg-[#030D20] transition-colors duration-500 hover:border-[#5EA2FF]/40"
        >
          <div className="p-8 lg:p-10">
            <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-[#5EA2FF] sm:text-3xl">
              PDF Estrategia
            </h3>
            <p className="mt-3 text-sm text-[#DCE8FF]">Todo el conocimiento, por escrito.</p>
            <div className="mt-10 flex flex-col items-center border border-[#5EA2FF]/15 py-12">
              <FileText className="h-16 w-16 text-[#2F7DF6]" strokeWidth={1.25} />
              <span className="mt-2 font-display text-2xl font-extrabold tracking-widest text-[#2F7DF6]">PDF</span>
            </div>
            <p className="mt-10 text-center font-mono text-sm font-bold tracking-[0.25em] text-[#5EA2FF]">
              +700 DIAPOSITIVAS
            </p>
            <p className="mt-2 text-center text-sm text-[#7A90B8]">
              La estrategia completa, explicada al detalle.
            </p>
            <ul className="mx-auto mt-8 max-w-xs space-y-3">
              {PDF_POINTS.map((pt) => (
                <li key={pt} className="flex items-center gap-3 text-sm text-[#DCE8FF]">
                  <span className="h-1.5 w-1.5 shrink-0 rotate-45 bg-[#2F7DF6]" aria-hidden="true" />
                  {pt}
                </li>
              ))}
            </ul>
          </div>
          <div className="mt-auto border-t border-[#5EA2FF]/15 p-8 text-center lg:p-10">
            <p className="font-display text-5xl font-extrabold tracking-tight text-[#5EA2FF]">500 €</p>
            <p className="mt-2 font-mono text-xs font-bold tracking-[0.3em] text-[#7A90B8]">PAGO ÚNICO</p>
            <a
              data-testid="pricing-cta-pdf-button"
              href={IG_DM}
              target="_blank"
              rel="noopener noreferrer"
              className="group/btn mt-8 flex items-center justify-center gap-3 border border-[#5EA2FF]/40 px-7 py-4 font-mono text-xs tracking-[0.25em] text-[#DCE8FF] transition-colors duration-300 hover:border-[#5EA2FF] hover:text-[#5EA2FF]"
            >
              QUIERO EL PDF
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover/btn:-translate-y-0.5 group-hover/btn:translate-x-0.5" />
            </a>
          </div>
        </article>
      </Reveal>
    </div>

    <Reveal delay={0.15}>
      <p className="mt-10 text-center font-mono text-[11px] tracking-[0.25em] text-[#7A90B8]">
        LOS BOTONES TE LLEVAN DIRECTO A DM DE INSTAGRAM — <span className="text-[#5EA2FF]">@BCTRADES__</span>
      </p>
    </Reveal>
  </section>
);
